module.exports = {

  data () {
    return {
      now: null
    }
  },

  computed: {
    idleWaitPeriod () {
      return this.$store.getters['activity/idleWaitPeriod']
    },

    idleLastActive () {
      return this.$store.getters['activity/lastActive']
    },

    idleTime () {
      return this.now - this.idleLastActive
    },

    dataWaitPeriod () {
      return this.$store.getters['pages/dataWaitPeriod']
    },

    dataLastRun () {
      return this.$store.getters['pages/dataLastRun']
    },

    dataTime () {
      return this.now - this.dataLastRun
    },

    appWaitPeriod () {
      return this.$store.getters['pages/appWaitPeriod']
    },

    appLastRun () {
      return this.$store.getters['pages/appLastRun']
    },

    appTime () {
      return this.now - this.appLastRun
    }
  },

  methods: {
    setupTimer () {
      // This is the global idle/activity handler
      // it listens for click activties in the app
      // This interval only rechecks state every 10 seconds
      // to save on timing
      this.now = Math.round(new Date() / 1000)

      // This sets the state which will trigger the reactivity in the Vue objects
      setInterval(function () {
        this.now = Math.round(new Date() / 1000)

        this.checkIdle()

        this.checkData()

        this.checkApp()
      }.bind(this), 1000)

      this.addClickListener()
    },

    addClickListener () {
      document.addEventListener('click', function () {
        this.$store.dispatch('activity/log')
      }.bind(this))
    },

    checkIdle () {
      console.log('CHECKING ILE', this.idleTime, this.idleWaitPeriod)
      if (this.idleTime > this.idleWaitPeriod) {
        console.log('IS IDLE. RSETTNG')
        this.$store.dispatch('activity/log') // to stop any potential repeating loops
        this.$router.push('/')
      }
    },

    checkData () {
      // Check for data fetch
      if (this.timeSinceLastDataFetch > this.dataFetchPeriod) {
        this.$store.dispatch('pages/getAllContent')
      }
    },

    checkApp () {
      // Check for app refresh
      if (this.appTime > this.appWaitPeriod) {
        if (this.$route.path === '/') {
          window.location.href = '/'
        }
      }
    }
  }
}
